import { useEffect, useRef } from "react";
import { Bold, Italic, List, ListOrdered } from "lucide-react";

export function RichTextEditor({ value, onChange, disabled, placeholder = "", testId = "rich-text" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
  }, [value]);
  const cmd = (c) => {
    document.execCommand(c);
    onChange(ref.current.innerHTML);
  };
  const tools = [["bold", Bold], ["italic", Italic], ["insertUnorderedList", List], ["insertOrderedList", ListOrdered]];
  return (
    <div className="border border-slate-300 rounded-md bg-white focus-within:ring-2 focus-within:ring-blue-600">
      {!disabled && (
        <div className="flex gap-1 border-b border-slate-200 p-1">
          {tools.map(([c, Icon]) => (
            <button key={c} type="button" onMouseDown={(e) => { e.preventDefault(); cmd(c); }} data-testid={`${testId}-${c}`}
              className="p-1.5 rounded hover:bg-slate-100 text-slate-600"><Icon className="h-4 w-4" /></button>
          ))}
        </div>
      )}
      <div ref={ref} contentEditable={!disabled} suppressContentEditableWarning data-placeholder={placeholder} data-testid={testId}
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="rte min-h-[110px] px-3 py-2 text-sm text-slate-700 outline-none" />
    </div>
  );
}
